import React, { Fragment } from 'react';
import * as Yup from 'yup';
import { Formik } from 'formik';

import {
    Typography,
    Divider,
    Dialog,
    DialogContent,
    DialogTitle,
    Box,
    Button,
    TextField,
    Grid,
    FormControl,
    InputLabel,
    Select,
    MenuItem
} from '@material-ui/core';


const Equipment = ({ item, closeEdition, updateValues, open }) => {

    return (
        <Fragment>

            <Dialog aria-modal="true" open={open} aria-labelledby="form-dialog-title" maxWidth="sm"  >
                <DialogTitle id="form-dialog-title">
                    <Typography
                        color="textPrimary"
                        variant="h4">
                        Equipamento
                    </Typography>
                </DialogTitle>
                <Divider />
                <DialogContent>

                    <Formik
                        initialValues={item}
                        validationSchema={
                            Yup.object().shape({
                                equipment: {
                                    name: Yup.string().max(50).required('Nome é obrigatório'),
                                    description: Yup.string().max(70).required('Descrição é o obrigatória'),
                                    manufacturer: Yup.string().max(70).required('Fabricante é obrigatório'),
                                    model: Yup.string().max(50).required('Modelo é obrigatorio'),
                                    serial: Yup.string().max(50).required('Número Serial é obrigatório'),
                                    type: Yup.string().max(3).required('Tipo é obrigatório'),
                                    device: Yup.string().max(50).required('Identificador MAC do Dispositivo é obrigatório'),
                                    locationname: Yup.string().max(50).required('Ponto de instalação é obrigatório'),
                                    panelname: Yup.string().max(50).required('Painel de controle é obrigatório')
                                }
                            })
                        }
                        onSubmit={(values, formik) => {
                            updateValues(values);
                            formik.setSubmitting(false);
                        }}
                    >
                        {({
                            errors,
                            handleBlur,
                            handleChange,
                            handleSubmit,
                            isSubmitting,
                            touched,
                            values
                        }) => (
                            <form onSubmit={handleSubmit}>
                                <Grid
                                    container
                                    spacing={2}
                                >
                                    <Grid
                                        item
                                        md={12}
                                        xs={12}>

                                        <TextField
                                            error={Boolean(touched.name && errors.name)}
                                            fullWidth
                                            label="Nome"
                                            margin="normal"
                                            name="name"
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            value={values.equipment.name}
                                            variant="outlined"
                                            InputLabelProps={{ shrink: true }}
                                        />

                                    </Grid>

                                    <Grid
                                        item
                                        md={12}
                                        xs={12}>
                                        <TextField
                                            error={Boolean(touched.description && errors.description)}
                                            fullWidth
                                            label="Descrição"
                                            margin="none"
                                            name="description"
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            value={values.equipment.description}
                                            variant="outlined"
                                            InputLabelProps={{ shrink: true }}
                                        />
                                    </Grid>

                                    <Grid
                                        item
                                        md={6}
                                        xs={12}>

                                        <TextField
                                            error={Boolean(touched.manufacturer && errors.manufacturer)}
                                            fullWidth
                                            label="Marca"
                                            margin="none"
                                            name="manufacturer"
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            value={values.equipment.manufacturer}
                                            variant="outlined"
                                            InputLabelProps={{ shrink: true }}
                                        />

                                    </Grid>

                                    <Grid
                                        item
                                        md={6}
                                        xs={12}>
                                        <TextField
                                            error={Boolean(touched.model && errors.model)}
                                            fullWidth
                                            label="Modelo"
                                            margin="none"
                                            name="model"
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            value={values.equipment.model}
                                            variant="outlined"
                                            InputLabelProps={{ shrink: true }}
                                        />
                                    </Grid>

                                    <Grid
                                        item
                                        md={6}
                                        xs={12}>
                                        <TextField
                                            error={Boolean(touched.serial && errors.serial)}
                                            fullWidth
                                            label="Número de Série"
                                            margin="none"
                                            name="serial"
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            value={values.equipment.serial}
                                            variant="outlined"
                                            InputLabelProps={{ shrink: true }}
                                        />
                                    </Grid>

                                    <Grid
                                        item
                                        md={6}
                                        xs={6}>
                                        <TextField
                                            error={Boolean(touched.device && errors.device)}
                                            fullWidth
                                            label="Dispositivo"
                                            disabled={localStorage.getItem('profile') != 'ENG'}
                                            margin="none"
                                            name="device"
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            value={values.device}
                                            variant="outlined"
                                            InputLabelProps={{ shrink: true }}
                                        />
                                    </Grid>

                                    <Grid
                                        item
                                        md={6}
                                        xs={12}>

                                        <FormControl variant="outlined" fullWidth margin="none">
                                            <InputLabel shrink htmlFor="type" required >Tipo de Equipamento</InputLabel>
                                            <Select notched
                                                disabled={localStorage.getItem('profile') != 'ENG'}
                                                autosize={true}
                                                error={Boolean(touched.type && errors.type)}
                                                helperText={touched.type && errors.type}
                                                value={values.type}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                label="Tipo de Equipamento"
                                                variant="outlined"
                                                inputProps={{
                                                    name: 'type',
                                                    id: 'type',
                                                }}
                                            >
                                                <MenuItem value={null}>
                                                    <em>Selecione uma das opções abaixo</em>
                                                </MenuItem>

                                            </Select>
                                        </FormControl>

                                    </Grid>

                                    <Grid
                                        item
                                        md={12}
                                        xs={12}>

                                        <FormControl variant="outlined" fullWidth margin="none">
                                            <InputLabel shrink htmlFor="locationname" required >Ponto de Instalação</InputLabel>
                                            <Select notched
                                                disabled={localStorage.getItem('profile') != 'ENG'}
                                                autosize={true}
                                                required
                                                error={Boolean(touched.locationname && errors.locationname)}
                                                helperText={touched.locationname && errors.locationname}
                                                value={values.location.name}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                label="Ponto de Instalação"
                                                variant="outlined"
                                                inputProps={{
                                                    name: 'locationname',
                                                    id: 'locationname',
                                                }}
                                            >
                                                <MenuItem value={null}>
                                                    <em>Selecione uma das opções abaixo</em>
                                                </MenuItem>

                                            </Select>
                                        </FormControl>

                                    </Grid>

                                    <Grid
                                        item
                                        md={6}
                                        xs={6}>

                                        <FormControl variant="outlined" fullWidth margin="none">
                                            <InputLabel shrink htmlFor="panelname" required >Painel de Controle</InputLabel>
                                            <Select notched
                                                disabled={localStorage.getItem('profile') != 'ENG'}
                                                autosize={true}
                                                error={Boolean(touched.panelname && errors.panelname)}
                                                helperText={touched.panelname && errors.panelname}
                                                value={values.panelname}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                label="Painel de Controle *"
                                                variant="outlined"
                                                inputProps={{
                                                    name: 'panelname',
                                                    id: 'panelname',
                                                }}
                                            >
                                                <MenuItem value={null}>
                                                    <em>Selecione uma das opções abaixo</em>
                                                </MenuItem>

                                            </Select>
                                        </FormControl>

                                    </Grid>

                                </Grid>
                                <Box my={1}></Box>
                                <Divider />

                                <Box my={1}>
                                    <Grid container
                                        direction="row"
                                        justify="flex-end"
                                        alignItems="baseline"
                                        spacing={1}  >
                                        <Grid item >
                                            <Button
                                                color="secondary"
                                                disabled={isSubmitting}
                                                size="small"
                                                type="submit"
                                                variant="contained">
                                                Salvar
                                            </Button>
                                        </Grid>
                                        <Grid item >
                                            <Button
                                                color="secondary"
                                                disabled={isSubmitting}
                                                size="small"
                                                variant="contained"
                                                onClick={() => { closeEdition() }}>
                                                Cancelar
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Box>

                            </form>
                        )}
                    </Formik>

                </DialogContent>

            </Dialog>

        </Fragment>
    );
};

export default Equipment;
